import React, { useState, useCallback } from "react";
import UploadFile from "./UploadFile";
import { Grid } from "@mui/material"; // Material UI
import { Button } from "antd"; // Ant Design
// import { createUploadFile } from "../services/uploadFile.service";
import { creatSignUpFiles } from "../services/uploadFile.service";

export default function UploadFilesModal({
  callback,
  reloadDocuments,
  setIsVisibleModal,
  setReloadDocuments,
}) {
  const [fileSelected, setFileSelected] = useState([]);

  const uploadFiles = useCallback(async () => {
    if (fileSelected.length > 0) {
      try {
        // Subir todos los archivos seleccionados
        const uploadResults = await Promise.all(
          fileSelected.map(async (file) => {
            const result = await creatSignUpFiles(file.file);

            // Si la subida es exitosa, devolver el resultado
            if (result.status === 200) {
              setReloadDocuments(!reloadDocuments);
              setIsVisibleModal(false);
              return result;
            }
            return null;
          })
        );

        // Llamar al callback con los resultados
        callback(uploadResults);
        setFileSelected([]);
      } catch (error) {
        console.error("Error uploading files:", error);
        callback(null);
      }
    } else {
      // No hay archivos seleccionados
      callback(null);
    }
  }, [fileSelected, callback]);

  // Maneja la selección de archivos desde el componente `UploadFile`
  const handleFileSelection = (selection) => {
    setFileSelected(selection);
    console.log("Archivos seleccionados:", selection);
  };

  // Al hacer clic en el botón, se suben los archivos
  const handleSaveClick = () => {
    uploadFiles();
  };

  return (
    <div>
      <Grid container spacing={3}>
        <Grid item xs={12}>
          <UploadFile
            setFileSelected={setFileSelected}
            fileSelected={fileSelected}
            label={"Seleccioná el o los documentos de plantilla para este requisito"}
            onCompleteFileSelection={handleFileSelection}
          />
        </Grid>

        <Grid item xs={4}></Grid>
        <Grid item xs={4}>
          <Button
            className="ButtonComponentStyle"
            type="primary"
            onClick={handleSaveClick}
          >
            Guardar
          </Button>
        </Grid>
        <Grid item xs={4}></Grid>
      </Grid>
    </div>
  );
}
